// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".bundle.98a1b70118b992a17c587bd6a3fbb88703a50252.js";
};